import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../../lib/api";
import { Loader2, ArrowLeft } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm">
        <Link to="/login" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground mb-6" data-testid="back-to-login">
          <ArrowLeft className="w-4 h-4" /> Back to sign in
        </Link>
        <div className="mb-6">
          <h2 className="text-2xl font-semibold tracking-tight">Forgot password?</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Enter your email and we&apos;ll send you a secure reset link.
          </p>
        </div>

        {sent ? (
          <div className="surface p-6 text-center" data-testid="forgot-password-sent">
            <div className="font-semibold">Check your email</div>
            <div className="text-sm text-muted-foreground mt-2">
              If <strong>{email}</strong> matches an account, a reset link has been sent. The link expires in 1 hour.
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="forgot-password-form">
            <div>
              <label className="text-sm font-medium block mb-1.5">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input-base"
                placeholder="you@agency.com"
                required
                data-testid="forgot-password-email"
              />
            </div>
            {error && (
              <div className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>
            )}
            <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="forgot-password-submit">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
